import { page } from "$app/stores";
import { get } from "svelte/store";
import type { UserActions } from "../../routes/types";
import type { ClientOrganization, ClientUser } from "../../models/ClientTypes";
import { randId } from "$sbelt/id";

export function getCurrentUser(): ClientUser {
	return get(page).data.loggedInUser as ClientUser;
}

export function getCurrentOrganization(): ClientOrganization | undefined {
	return getCurrentUser().organization;
}

export function getUserActions() {
	return get(page).data.userActions as UserActions;
}

export function getClassicWebUrl() {
	return get(page).data.classicWebUrl as string;
}

export function getIsInsideConnect() {
	return get(page).data.isInsideConnect as boolean;
}

export function getIsLoggedIn() {
	return get(page).data.isLoggedIn as boolean;
}

export function getCSRF() {
	return get(page).data.csrf as string;
}

export const currentDeviceId = deviceId();

function deviceId() {
	if (import.meta.env.SSR) {
		return "-1";
	}
	const id = sessionStorage.getItem("__deviceId") || randId("d");
	sessionStorage.setItem("__deviceId", id);
	return id;
}
